import moment from 'moment';
import { mapGetters, mapState } from 'vuex';
import fallbackImg from '#/assets/img/fallback.svg';

const catalogItemMixin = {
  computed: {
    ...mapState({
      teamAgeGroups: (state) => state.items.teamAgeGroups
    }),
    ...mapGetters([
      'getTeamTypeAudience',
      'getItemAudience',
      'getItemAudiencesLong',
      'getItemAudiencesShort'
    ]),
    displayOwnerName: () => (owner) => {
      return owner && owner?.name != 'Base Curio';
    }
  },
  methods: {
    isExpired(i) {
      if (i && i.item) {
        return i.item.status == 'expired';
      } else {
        return i?.status == 'expired';
      }
    },
    //If there is no screenerUID, the media is not valid
    hasNoScreener(i) {
      const screenerUID = i.screener
        ? i.screener.uid
        : i.screeners && i.screeners.length
          ? i.screeners[0].uid
          : '';

      return screenerUID === '';
    },

    channelUnsubscribe() {
      //ChannelUnsubscribe : logique à faire
      return false;
    },
    lastChance(i) {
      if (i?.status == 'published') {
        return i.owner?.end_of_rights
          ? moment(i.owner.end_of_rights).diff(moment(), 'days') <= 30
          : false;
      } else {
        return false;
      }
    },
    imgThumbnail(i, size) {
      let imgSrc = '/img/fallback.svg';

      if (this.isExpired(i)) {
        imgSrc = '/img/th_end_rights.svg';
      } else if (size == 'medium' && i.image_versions?.medium) {
        imgSrc = i.image_versions.medium;
      } else if (i.image_versions?.large) {
        imgSrc = i.image_versions.large;
      } else if (i.image) {
        imgSrc = i.image;
      }
      return imgSrc;
    },
    imageUrlFallback(event) {
      event.target.src = fallbackImg;
    }
  }
};

export { catalogItemMixin };
